import React from 'react';
import { useTranslation } from 'react-i18next';
import { EnglishLockedHierarchyIcon } from '../admin/EnglishLockedHierarchyIcon';

export const EnglishLockedContentHintIcon: React.FC<{
  onClick: () => void;
  className?: string;
  dataTourId?: string;
}> = ({ onClick, className = '', dataTourId }) => {
  const { t } = useTranslation('learning');

  return (
    <button
      type="button"
      data-tour-id={dataTourId}
      onClick={onClick}
      className={`inline-flex shrink-0 items-center justify-center rounded-md border border-sky-200/80 bg-white/90 p-1 text-sky-600 shadow-sm transition-colors hover:bg-sky-50 hover:text-sky-700 dark:border-sky-800/50 dark:bg-gray-900/90 dark:text-sky-400 dark:hover:bg-sky-950/50 dark:hover:text-sky-300 ${className}`}
      aria-label={t('nonFarsiContent.title')}
      title={t('nonFarsiContent.title')}
    >
      <EnglishLockedHierarchyIcon />
    </button>
  );
};
